// migrated 1:1 from @nexato/nx-core-module (#682)
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import * as fromGraphQl from './graphql';
import { ApolloService } from '../../apollo.service';
import { IssueType } from '../../../entities/issue/issue-type';
import { IssueStatusGroup } from '../../../entities/issue/issue-status-group';

/**
 * The groups service.
 */
@Injectable()
export class IssueStatusGroupService {
  constructor(
    private apolloService: ApolloService,
  ) {
  }

  public getIssueStatusGroups(): Observable<IssueStatusGroup[]> {
    return this.apolloService.query<fromGraphQl.GetIssueStatusGroupsResponse>(fromGraphQl.GET_STATUSGROUPS_QUERY)
      .pipe(
        take(1),
        switchMap( (result) => {
          return of( IssueStatusGroup.createIssueStatusGroups(result.data.getIssueStatusGroups));
        })
      );
  }

}
